// extracted by mini-css-extract-plugin
export var productImage = "_pv-1";
export var viewLink = "_pv-2";
export var wishlistItem = "_pv-0";